import imageDe from '../images/de/sensotrend_dashboard_sharing.png';
import imageEn from '../images/en/sensotrend_dashboard_sharing.png';
import imageEs from '../images/es/sensotrend_dashboard_sharing.png';
import imageFi from '../images/fi/sensotrend_dashboard_sharing.png';
import imageFr from '../images/fr/sensotrend_dashboard_sharing.png';
import imageIt from '../images/it/sensotrend_dashboard_sharing.png';
import imageNo from '../images/no/sensotrend_dashboard_sharing.png';
import imageSv from '../images/sv/sensotrend_dashboard_sharing.png';

export const dashboardSharingImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
